import React from 'react';
import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';

const PromptingLevelSection = ({
  dataPoint,
  index,
  handleCheckboxChange,
  handleFieldChange,
  allGoalData,
}) => {
  const shouldShowPromptingLevel = 
    allGoalData?.DataEntrySelection?.DataEntrySelection?.includes('Add Prompting Level') ||
    dataPoint?.selectedOptions?.includes('Add Prompting Level');

  if (!shouldShowPromptingLevel) {
    return null;
  }

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={dataPoint.selectedOptions.includes(
              'Add Prompting Level'
            )}
            onChange={(e) => handleCheckboxChange(index, e)}
            value='Add Prompting Level'
          />
        }
        label='Add Prompting Level'
      />

      {dataPoint.selectedOptions.includes('Add Prompting Level') && (
        <Box sx={{ ml: 3, pl: 2, borderLeft: '2px solid #e0e0e0' }}>
          <Box sx={{ gap: 2, marginTop: '10px' }}>
            <Typography variant='body1'>Prompting Level:</Typography>
            <FormControl sx={{ minWidth: 300, width: '70%' }}>
              <Select
                value={dataPoint.promptingLevel || ''}
                onChange={(e) =>
                  handleFieldChange(index, 'promptingLevel', e.target.value)
                }
                displayEmpty
                margin='dense'
                className='input-height'
                sx={{ backgroundColor: 'var(--clr-mindly-white)' }}
              >
                <MenuItem value=''>Select prompting type</MenuItem>
                {/* Physical Prompting */}
                <MenuItem value='physical-full-total-assist'>
                  Physical → Full → Total Assist (75+% effort)
                </MenuItem>
                <MenuItem value='physical-full-maximal-assist'>
                  Physical → Full → Maximal Assist
                </MenuItem>
                <MenuItem value='physical-partial-moderate'>
                  Physical → Partial → Moderate
                </MenuItem>
                <MenuItem value='physical-partial-minimal'>
                  Physical → Partial → Minimal
                </MenuItem>

                {/* Verbal Prompting */}
                <MenuItem value='verbal-minimal'>Verbal → Minimal</MenuItem>
                <MenuItem value='verbal-moderate'>Verbal → Moderate</MenuItem>
                <MenuItem value='verbal-maximum'>Verbal → Maximum</MenuItem>

                {/* Other prompting types */}
                <MenuItem value='permanent-visual'>
                  Permanent Visual Prompting
                </MenuItem>
                <MenuItem value='visual'>Visual Prompting</MenuItem>
                <MenuItem value='gestural'>Gestural Prompting</MenuItem>
                <MenuItem value='modeling'>Modeling</MenuItem>
                <MenuItem value='positional'>Positional Prompting</MenuItem>
                <MenuItem value='independent'>Independent</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      )}
    </>
  );
};

export default PromptingLevelSection;
